var BufferView = require('bufferview');
var ChannelView = require('channelview');
var ThreadStatusView = require('threadstatusview');

var ThreadView = BufferView.extend({
    className: 'buffercontainer buffercontainer--thread',
    id: function () {
        return;
    },
    initialize: function (options) {
        this.status = new ThreadStatusView(options);
        this.listenTo(this.model, 'delete', this.remove);
        this.visible = true;
        BufferView.prototype.initialize.apply(this, arguments);
    },
    renderConnectionStatus: function () {
        return this.connectionStatus;
    },
    postrender: function () {
        if (this.buffer.isChannel()) {
            this.renderMode();
            this.buffer.bind('modeChange', this.renderMode, this);
        }
    },
    renderMode: function () {
        if (this.buffer.isChannel()) {
            return ChannelView.prototype.renderMode.apply(this);
        }
    },
    renderUserMember: function () {
        if (this.buffer.isChannel()) {
            return ChannelView.prototype.renderUserMember.apply(this);
        }
    }
});


module.exports = ThreadView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/threadview.js
// module id = t2v7
// module chunks = 1